import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0C1D2E]">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=large%20industrial%20steel%20warehouse%20construction%20site%20in%20Chile%2C%20workers%20building%20metal%20structure%20frame%2C%20dramatic%20dark%20sky%20with%20orange%20sunset%20light%2C%20professional%20construction%20photography%2C%20wide%20angle%2C%20industrial%20architecture%2C%20steel%20beams%20and%20columns%2C%20heavy%20machinery%20silhouette%2C%20high%20contrast%20dark%20moody%20atmosphere%2C%20premium%20corporate%20photography%20style&width=1920&height=1080&seq=hero002&orientation=landscape"
          alt="Construcción industrial en Chile - IngemetalSur"
          className="w-full h-full object-cover object-top opacity-80"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0C1D2E]/70 via-[#0C1D2E]/50 to-[#0C1D2E]/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0C1D2E] via-transparent to-[#0C1D2E]/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-12">
        <div className="max-w-2xl">
          {/* Badge */}
          <Link
            to="/nosotros#premio-sernageomin"
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6 hover:bg-white/20 transition-all duration-200 cursor-pointer group"
          >
            <i className="ri-award-fill text-[#C88A2A] text-sm"></i>
            <span className="text-white/80 text-xs font-semibold tracking-wide uppercase">Premio SERNAGEOMIN · Seguridad Minera</span>
            <i className="ri-arrow-right-line text-white/40 text-xs group-hover:text-white/80 transition-colors"></i>
          </Link>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-[1.1] mb-4 tracking-tight">
            Más de 25 años<br />
            construyendo<br />
            <span className="text-[#C88A2A]">infraestructura industrial</span><br />
            en Chile
          </h1>

          <p className="text-white/70 text-base md:text-lg leading-relaxed mb-8 max-w-lg font-light">
            Estructuras metálicas, galpones industriales, obras civiles y proyectos comerciales con cobertura nacional.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <Link
              to="/proyectos"
              className="inline-flex items-center justify-center gap-2 bg-[#C88A2A] hover:bg-[#A06B1A] text-white font-bold px-8 py-4 rounded-md transition-all duration-200 text-center whitespace-nowrap text-base"
            >
              <i className="ri-folder-line text-lg"></i>
              Ver Proyectos
            </Link>
            <a
              href="https://wa.me/56992265118?text=Hola%2C%20me%20interesa%20cotizar%20un%20proyecto"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/30 hover:border-white/60 text-white hover:bg-white/10 font-bold px-8 py-4 rounded-md transition-all duration-200 text-center whitespace-nowrap text-base"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Cotizar Proyecto
            </a>
          </div>

          {/* Bottom stats */}
          <div className="flex flex-wrap gap-8 border-t border-white/20 pt-6">
            {[
              { value: '+25', label: 'Años de experiencia' },
              { value: '+300', label: 'Proyectos ejecutados' },
              { value: '20+', label: 'Ciudades de cobertura' },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
                <div className="text-white/40 text-xs mt-1 uppercase tracking-wider">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/30 text-xs tracking-[0.2em] uppercase font-medium">Scroll</span>
        <i className="ri-arrow-down-line text-white/30 text-lg"></i>
      </div>
    </section>
  );
};

export default HeroSection;